module.exports = __webpack_public_path__ + "img/grand-palm-hotel.decc76a5.jpg";